import { Type } from "@sinclair/typebox";
import { campaignScenarioTypeSchema, campaignSourceSchema, campaignLineEvidenceProperties, campaignEconomicSummaryProperties } from "./campaigns.js";
import { quoteCompositionSchema, quoteLineCompositionProperties } from "./quote-composition.js";
const decimal = Type.String({ pattern: "^\\d{1,10}(?:\\.\\d{1,4})?$" });
export const campaignQuoteLineSchema = Type.Object({
    ...quoteLineCompositionProperties,
    ...campaignLineEvidenceProperties,
    id: Type.String({ minLength: 1, maxLength: 120 }),
    lineKey: Type.String({ minLength: 1, maxLength: 120 }),
    description: Type.String({ minLength: 1, maxLength: 12000 }),
    unit: Type.String({ minLength: 1, maxLength: 40 }),
    quantity: Type.Union([decimal, Type.Null()]),
    finalUnitPrice: Type.Union([decimal, Type.Null()]),
    amount: Type.Optional(Type.Union([decimal, Type.Null()])),
    referenceCode: Type.Optional(Type.String()),
    suggestedUnitPrice: Type.Union([decimal, Type.Null()]),
    pricingCriterion: Type.Optional(Type.String({ maxLength: 2000 })),
    overrideReason: Type.Optional(Type.String({ maxLength: 2000 })),
    catalogItemId: Type.Optional(Type.String({ format: "uuid" })),
    publicReferenceItemId: Type.Optional(Type.String({ format: "uuid" })),
    publicReference: Type.Optional(Type.Object({ code: Type.String(), price: decimal }))
}, { additionalProperties: false });
export const campaignQuoteSaveSchema = Type.Object({
    expectedRevision: Type.Integer({ minimum: 1 }),
    removedLineKeys: Type.Optional(Type.Array(Type.String({ minLength: 1, maxLength: 120 }), {
        maxItems: 200,
        uniqueItems: true
    })),
    conditions: Type.String({ maxLength: 30000 }),
    composition: quoteCompositionSchema,
    lines: Type.Array(campaignQuoteLineSchema, { minItems: 1, maxItems: 200 })
}, { additionalProperties: false });
const preliminaryDraftProperties = {
    ...campaignEconomicSummaryProperties,
    contractVersion: Type.Optional(Type.Literal(2)),
    revision: Type.Integer({ minimum: 1 }),
    status: Type.Literal("preliminary"),
    vat: Type.Null(),
    totalIncludingVat: Type.Null(),
    subtotal: decimal,
    conditions: Type.String(),
    composition: quoteCompositionSchema,
    lines: Type.Array(campaignQuoteLineSchema),
    removedLines: Type.Optional(Type.Array(campaignQuoteLineSchema)),
    sources: Type.Array(campaignSourceSchema),
    assumptions: Type.Array(Type.String()),
    limitations: Type.Array(Type.String()),
    catalogDigest: Type.String(),
    updatedAt: Type.String()
};
export const harnessQuoteDraftSchema = Type.Object({
    ...preliminaryDraftProperties,
    origin: Type.Literal("harness"),
    runId: Type.String({ minLength: 1, maxLength: 160 }),
    caseId: Type.String({ minLength: 1, maxLength: 120 }),
    variantId: Type.String({ minLength: 1, maxLength: 120 }),
    sourceDigest: Type.String({ pattern: "^[a-f0-9]{64}$" }),
    catalogVersionId: Type.String({ format: "uuid" })
}, { additionalProperties: false });
export const campaignQuoteDraftSchema = Type.Union([
    Type.Object({
        ...preliminaryDraftProperties,
        origin: Type.Optional(Type.Literal("replay")),
        campaignId: Type.String({ format: "uuid" }),
        campaignItemId: Type.String({ format: "uuid" }),
        scenarioType: campaignScenarioTypeSchema
    }),
    harnessQuoteDraftSchema
]);
//# sourceMappingURL=campaign-quote.js.map